const meta = {
  module: "languages",
};

export default [
  {
    path: `/languages`,
    redirect: "/languages/page/1",
  },
  {
    path: `/languages/page`,
    redirect: "/languages/page/1",
  },
  {
    path: `/languages/page/:page`,
    name: "languages",
    component: () =>
      import(
        /* webpackChunkName: "languages" */ "@/modules/languages/views/index.vue"
      ),
    meta: {
      ...meta,
    },
  },
  {
    path: `/languages/create`,
    name: "languages/create",
    component: () =>
      import(
        /* webpackChunkName: "languages/create" */ "@/modules/languages/views/create.vue"
      ),
    meta: {
      ...meta,
      action: "create",
    },
  },
  {
    path: `/languages/edit/:id`,
    name: "languages/edit",
    component: () =>
      import(
        /* webpackChunkName: "languages/edit" */ "@/modules/languages/views/edit.vue"
      ),
    meta: {
      ...meta,
      action: "edit",
    },
  },
];
